 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"DueDiligence-vue":"DueDiligence-vue","EmailLogs-vue~MyAccount-vue":"EmailLogs-vue~MyAccount-vue","EmailLogs-vue":"EmailLogs-vue","Home-vue~MyAccount-vue":"Home-vue~MyAccount-vue","MyAccount-vue":"MyAccount-vue","Home-vue":"Home-vue","OpenAccount-vue":"OpenAccount-vue","PageNotFound-vue":"PageNotFound-vue","ResetPassword-vue":"ResetPassword-vue","utils-CurrencyConverter-vue":"utils-CurrencyConverter-vue","utils-Utilities-vue":"utils-Utilities-vue","utils-FAQs-Alerts-vue":"utils-FAQs-Alerts-vue","utils-FAQs-FAQs-vue":"utils-FAQs-FAQs-vue","utils-FAQs-Investing-vue":"utils-FAQs-Investing-vue","utils-FAQs-Terminology-vue":"utils-FAQs-Terminology-vue","utils-Glossary-vue":"utils-Glossary-vue","utils-RiskProfile-vue":"utils-RiskProfile-vue","utils-how-to-BuySell-vue":"utils-how-to-BuySell-vue","utils-how-to-HowTo-vue":"utils-how-to-HowTo-vue","utils-how-to-RemitCash-vue":"utils-how-to-RemitCash-vue","utils-how-to-SendCash-vue":"utils-how-to-SendCash-vue"}[chunkId]||chunkId) + "." + {"DueDiligence-vue":"22314125","EmailLogs-vue~MyAccount-vue":"40df5516","EmailLogs-vue":"f6ebe681","Home-vue~MyAccount-vue":"28c6f506","MyAccount-vue":"4cad35ca","Home-vue":"503c50a9","OpenAccount-vue":"2e1c2e96","PageNotFound-vue":"a791dbf9","ResetPassword-vue":"90bdf91d","utils-CurrencyConverter-vue":"facca408","utils-Utilities-vue":"0f1b1ec2","utils-FAQs-Alerts-vue":"1f8a6a40","utils-FAQs-FAQs-vue":"cd202132","utils-FAQs-Investing-vue":"6ebe9531","utils-FAQs-Terminology-vue":"f1fe2abc","utils-Glossary-vue":"1018de00","utils-RiskProfile-vue":"1f585573","utils-how-to-BuySell-vue":"bd79ba05","utils-how-to-HowTo-vue":"3839d30a","utils-how-to-RemitCash-vue":"501a5e89","utils-how-to-SendCash-vue":"f499674e","chunk-5faa7825":"f261e00c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"DueDiligence-vue":1,"EmailLogs-vue~MyAccount-vue":1,"EmailLogs-vue":1,"Home-vue~MyAccount-vue":1,"MyAccount-vue":1,"Home-vue":1,"OpenAccount-vue":1,"PageNotFound-vue":1,"ResetPassword-vue":1,"utils-CurrencyConverter-vue":1,"utils-Utilities-vue":1,"utils-FAQs-Alerts-vue":1,"utils-FAQs-FAQs-vue":1,"utils-FAQs-Investing-vue":1,"utils-FAQs-Terminology-vue":1,"utils-Glossary-vue":1,"utils-RiskProfile-vue":1,"utils-how-to-BuySell-vue":1,"utils-how-to-HowTo-vue":1,"utils-how-to-RemitCash-vue":1,"utils-how-to-SendCash-vue":1,"chunk-5faa7825":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"DueDiligence-vue":"DueDiligence-vue","EmailLogs-vue~MyAccount-vue":"EmailLogs-vue~MyAccount-vue","EmailLogs-vue":"EmailLogs-vue","Home-vue~MyAccount-vue":"Home-vue~MyAccount-vue","MyAccount-vue":"MyAccount-vue","Home-vue":"Home-vue","OpenAccount-vue":"OpenAccount-vue","PageNotFound-vue":"PageNotFound-vue","ResetPassword-vue":"ResetPassword-vue","utils-CurrencyConverter-vue":"utils-CurrencyConverter-vue","utils-Utilities-vue":"utils-Utilities-vue","utils-FAQs-Alerts-vue":"utils-FAQs-Alerts-vue","utils-FAQs-FAQs-vue":"utils-FAQs-FAQs-vue","utils-FAQs-Investing-vue":"utils-FAQs-Investing-vue","utils-FAQs-Terminology-vue":"utils-FAQs-Terminology-vue","utils-Glossary-vue":"utils-Glossary-vue","utils-RiskProfile-vue":"utils-RiskProfile-vue","utils-how-to-BuySell-vue":"utils-how-to-BuySell-vue","utils-how-to-HowTo-vue":"utils-how-to-HowTo-vue","utils-how-to-RemitCash-vue":"utils-how-to-RemitCash-vue","utils-how-to-SendCash-vue":"utils-how-to-SendCash-vue"}[chunkId]||chunkId) + "." + {"DueDiligence-vue":"5d8c3a69","EmailLogs-vue~MyAccount-vue":"7cf7d179","EmailLogs-vue":"9006f7af","Home-vue~MyAccount-vue":"973cefe0","MyAccount-vue":"78ce3bd8","Home-vue":"f356af79","OpenAccount-vue":"2f7e2af7","PageNotFound-vue":"4359e324","ResetPassword-vue":"0611a59e","utils-CurrencyConverter-vue":"859d6557","utils-Utilities-vue":"31e0095b","utils-FAQs-Alerts-vue":"b8b4e09f","utils-FAQs-FAQs-vue":"88035620","utils-FAQs-Investing-vue":"235a6d0d","utils-FAQs-Terminology-vue":"d58f0d0c","utils-Glossary-vue":"fc42e60f","utils-RiskProfile-vue":"3f59e934","utils-how-to-BuySell-vue":"a24d05ac","utils-how-to-HowTo-vue":"370c7858","utils-how-to-RemitCash-vue":"2a332406","utils-how-to-SendCash-vue":"e605be75","chunk-5faa7825":"94917432"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
